export default __webpack_public_path__ + "static/select-replay-control-flag-light-mode-094a86c076cc4c528d361bbaaeb87412.png";